/**
 * Sync the open Decision Trail item through the `?why=` search param so a
 * trail view is shareable as a URL ("the answer is a URL", canon 27 §5).
 * Host surfaces derive the rank label themselves.
 */

import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useDecisionTrailParam(): {
  trailItemId: string | null;
  openTrail: (itemId: string) => void;
  closeTrail: () => void;
} {
  const [searchParams, setSearchParams] = useSearchParams();
  const trailItemId = searchParams.get('why');

  const openTrail = useCallback(
    (itemId: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set('why', itemId);
          return next;
        },
        { replace: false }
      );
    },
    [setSearchParams]
  );

  const closeTrail = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete('why');
        return next;
      },
      { replace: false }
    );
  }, [setSearchParams]);

  return { trailItemId, openTrail, closeTrail };
}
